/** Display formatting only. This must never select a financial business date. */
export function normalizeAccountingDisplayTimezone(value) {
    if (typeof value !== 'string' ||
        value.length > 64 ||
        !/^[A-Za-z][A-Za-z0-9_+.-]*(\/[A-Za-z0-9_+.-]+)*$/.test(value))
        return null;
    try {
        return new Intl.DateTimeFormat('en', { timeZone: value }).resolvedOptions().timeZone;
    }
    catch {
        return null;
    }
}
//# sourceMappingURL=accounting-display.js.map